import React from 'react';
import { useTranslation } from 'react-i18next';
import './AppPasswordQuality.css';
import {
  strHasLower,
  strHasMinLength,
  strHasNumber,
  strHasSpecial,
  strHasUpper,
} from '../utils/strings';

type AppPasswordQualityProps = {
  minLength: number;
  password: string;
};

export default function AppPasswordQuality({
  minLength,
  password,
}: AppPasswordQualityProps) {
  const [t] = useTranslation('global');

  const pwLenght = () => {
    if (strHasMinLength(password, minLength)) {
      return 'success';
    }
    return '';
  };

  const pwUpper = () => {
    if (strHasUpper(password)) {
      return 'success';
    }
    return '';
  };

  const pwLower = () => {
    if (strHasLower(password)) {
      return 'success';
    }
    return '';
  };

  const pwNumber = () => {
    if (strHasNumber(password)) {
      return 'success';
    }
    return '';
  };

  const pwSpecial = () => {
    if (strHasSpecial(password)) {
      return 'success';
    }
    return '';
  };

  return (
    <div className="app-password-quality pt-1">
      <div>{t('register.pwrequirements')}</div>
      <div className={pwLenght()}>
        {t('register.pwlength', { n: minLength })}
      </div>
      <div className={pwUpper()}>{t('register.pwupper')}</div>
      <div className={pwLower()}>{t('register.pwlower')}</div>
      <div className={pwNumber()}>{t('register.pwnumber')}</div>
      <div className={pwSpecial()}>{t('register.pwspecial')}</div>
    </div>
  );
}
